
















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { User, Info, Device, Message} from '@/types/core';

import VueError from '@/components/VueError.vue';
import Loading from '@/components/Loading.vue';
import LoraWanUpdateView from '@/components/LoraWanUpdateView.vue';
import CustomSectionHeader from '@/components/CustomSectionHeader.vue';
import MessageMobile from "@/components/device/MessageMobile.vue";
import TimestampAgo from "@/components/TimestampAgo.vue"; 

import moment from 'moment';
import tippy from 'tippy.js';
import { curCoreClient, CoreClient } from '../../services/CoreClient';

@Component({
  components:{
    VueError,
    Loading,
    MessageMobile,
    LoraWanUpdateView,
    CustomSectionHeader,
    TimestampAgo
  }
})
export default class MessageSection extends Vue {

  @Prop({ default: () => {},  type: Object}) device!:Device;

  error:string = '';
  httpBusy:boolean = false;
  offset = 0;
  messPerPage = parseInt(process.env.VUE_APP_DEVICE_MESS_PER_PAGE!, 10);
  dbMessageList:Message[] = [];
  messageList:Message[] = [];

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;
    
  async mounted() {
    
    this.loadMessages();
  }

  async loadMessages() {

    this.httpBusy = true;
    this.error = '';

    const reply = await this.coreClient.getLatestMessages({deviceId: this.device.deviceId, limit: 200});

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});
    
    if(reply.errorMsg)
      return this.error = `Unable to retrieve latest messages for device ${this.$route.params.id}: ${reply.errorMsg}`;

    this.dbMessageList = reply.messageList!;

    this.dbMessageList.map((msg) => msg.isComputed = msg.readingList && msg.readingList.some((x) => x.label && x.label.includes('rdp')));

    this.offset = 0;
    this.refreshMessageList();
  }

  refreshMessageList() {
    this.messageList = this.dbMessageList.slice(this.offset, this.offset+this.messPerPage);
  }

  getLoraPort(message:Message):string|number {

    if(message.port)
      return message.port;

    if(message.network && message.network.loraWan)
      return message.network.loraWan.loraPort;

    return 'N/A';
  }

  getPayload(message: Message): { value: string, type: string } {
    let payload = {
      value: message.hexPayload,
      type: 'hex'
    }

    if (message.isComputed) {
      payload.value = `- readings only message - computed -`;
      payload.type = 'string';
    } else if (message.origMsgTs) {
      payload.value = `- readings only message - logged reading -`;
      payload.type = 'string';
    }

    return payload;
  }

  goBack() {
    this.offset+=this.messPerPage;
    this.refreshMessageList();
  }

  goForward() {
    this.offset-=this.messPerPage;
    this.refreshMessageList();
  }

  get showMessageTable() {
    return !this.httpBusy && this.messageList.length > 0;
  }
  get showMessageNav() { 
    return !this.httpBusy && this.messageList.length > 0;
  }

  get showNoMessages() {
    return !this.httpBusy && this.messageList.length === 0;
  }

  get olderMessagesEnabled() {
    return (this.offset + this.messPerPage) < this.dbMessageList.length;
  }

  get newerMessagesEnabled() {
    return this.offset > 0;
  }

}

